import script from "./DepartmentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__